module.exports = __webpack_public_path__ + "static/bread-banner-2-370459bcf02ea50db9996f81d98b0eb1.jpg";